import _ from 'lodash';
import vxSpinner from '../../common/vx-spinner/vx-spinner.vue';
import vxStepperControl from '../../common/vx-stepper-control/vx-stepper-control.vue';
import vxCartProductTile from '../../manage-shopping-cart/vx-cart-product-tile/vx-cart-product-tile.vue';
import vxDropdownPrimary from '../../common/vx-dropdown-primary/vx-dropdown-primary.vue';
import vxModal from '../../common/vx-modal/vx-modal.vue';
import vxAddEditAddress from '../../common/vx-add-edit-address/vx-add-edit-address.vue';
import vxSplitAddress from '../vx-split-address/vx-split-address.vue';
import globals from '../../common/globals';
import flyoutBannerMixin from '../../common/vx-flyout-banner/vx-flyout-banner-mixin';
import vxProductTile from '../../common/vx-product-tile/vx-product-tile.vue';
import mobileMixin from '../../common/mixins/mobile-mixin';
import CheckoutService from '../../common/services/checkout-service';
import checkoutTrackingMixin from '../../common/mixins/checkout-tracking-mixin';

import { checkoutEventBus, eventBus } from '../../../modules/event-bus';
import { ProductAvailability, discount } from '../../common/mixins/vx-enums';

export default {
  name: 'vx-multi-shipping-address',
  mixins: [flyoutBannerMixin, mobileMixin, checkoutTrackingMixin],
  components: {
    vxSpinner,
    vxCartProductTile,
    vxDropdownPrimary,
    vxAddEditAddress,
    vxModal,
    vxStepperControl,
    vxSplitAddress,
    vxProductTile,
  },
  props: {
    // Indicates if Multiple/Single Shipping is opted
    isShippingMultiple: Boolean,
    // Text coming from property file
    i18n: Object,
    // All the address of the user
    userAddresses: Array,
    // Products in cart
    visibleEntries: {
      type: Array,
    },
    isGuest: Boolean,
    // Indicates we need to show pallet shipment
    palletShipment: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      globals,
      checkoutService: new CheckoutService(),
      isSplitApplicable: false,
      promotionData: {},
      quantityError: false,
      addressEmptyError: false,
      splitToSameAddressError: false,
      addressAvailable: false,
      isSaved: false,
      isEditable: true,
      splitEntries: [],
      savedAddress: {},
      restrictionError: false,
      currentAvailableAddresses: [],
      uniqueSavedAddresses: [],
      allSelectedAddresses: [],
      shippingDetails: [],
      shippingAddress: [],
      restrictedItems: [],
      splitEntryDataArray: [],
      contactUsUrl: '',
      ProductAvailability,
      discount,
      parentMounted: false,
      useAddressClicked: false,
      allUserSavedAddresses: [],
      modalScrollable: true,
      defaultAddress: {},
      deliveryId: '',
      showSelectedAddress: false,
    };
  },
  computed: {},
  mounted() {
    this.parentMounted = true;
    if (globals.isB2B()) {
      this.sendEventToDataLayer('checkout_option', 2, 'Ship to multiple locations');
      this.isSplitApplicable = true;
    }
    if (this.userAddresses && this.userAddresses.length !== 0) {
      this.allUserSavedAddresses = this.formAddressValues(this.userAddresses);
      this.addressAvailable = true;
    } else {
      this.addressAvailable = false;
    }
    this.contactUsUrl = this.globals.getNavigationUrl('contactUs');
    eventBus.$on('removeScrollbar', (isRemoveScrollbar) => {
      this.modalScrollable = !isRemoveScrollbar;
    });
  },
  methods: {
    /**
     * This function is triggered when user tries to add new address
     */
    addNewAddress() {
      this.$refs.addNewAddressModal.open();
    },
    /**
     * This function is triggered when user tries to change shipping address
     */
    toggleEditMode() {
      this.isSaved = false;
      this.isEditable = true;
      this.allSelectedAddresses = [];
      this.savedAddress = [];
    },
    /**
     * This function forms the request congif data for Shipping restriction call (saving shipping address)
     */
    saveRequestData() {
      // shipping addresses request
      const requestdata = {
        shippingDetails: _.flattenDeep(this.shippingDetails),
        shippingAddress: [
          {
            splitEntry: this.splitEntries,
          },
        ],
      };
      return requestdata;
    },
    /**
     * This function checks if the address to be used is for a guest user or not
     */
    useThisAddress() {
      if (!this.isGuest) {
        this.$emit('call-get-addresses');
      } else {
        this.$emit('call-guest-get-addresses');
      }
      this.addressAvailable = true;
    },
    /**
     * This function sets address for all dropdowns in multi shipping
     * @param  {Object} data address
     */
    setAddressForAllEntries(data) {
      for (let i = 0; i < this.$refs.splitQtyAddress.length; i += 1) {
        this.$refs.splitQtyAddress[i].setAddressDropdownValue(data);
      }
    },
    /**
     * This function gets values of all address
     * @param  {Array} data address array
     */
    getAddressValues(data) {
      this.userAddresses = data;
      if (this.deliveryId && this.userAddresses.length !== 0) {
        for (let i = 0; i < this.userAddresses.length; i += 1) {
          if (
            this.userAddresses[i].id === this.deliveryId ||
            (this.userAddresses.length - 1 === i && this.globals.isEStores())
          ) {
            this.savedAddress.label = this.formAddressString(
              this.userAddresses[i],
            );
            this.savedAddress.value = this.userAddresses[i];
            break;
          }
        }
        // for (let j = 0; j < this.$refs.splitQtyAddress.length; j += 1) {
        // this.$refs.splitQtyAddress[this.$refs.splitQtyAddress.length - 1].setAddressDropdownValue(
        //   this.savedAddress,
        // );
        // }
        this.deliveryId = '';
      }
      this.allUserSavedAddresses = this.formAddressValues(this.userAddresses);
      // this commented out code would automatically send user to next section whether or not they were done filling in all addresses
      // if (this.showSelectedAddress) {
      //   this.toggleViewMode();
      //   this.showSelectedAddress = false;
      // }
    },
    /**
     * This function saves new address
     * @param  {Object} data address
     */
    saveThisAddress(data) {
      this.$refs.addNewAddressModal.close();
      this.checkoutService.addAddress(
        {},
        this.handleSaveAddressResponse,
        this.handleSaveAddressError,
        data.address.value,
      );
      this.$refs.spinner.showSpinner();
      this.savedAddress = data.address;
      this.showSelectedAddress = data.showSelectedAddress;
    },
    /**
     * This function handles the error of saves new address
     */
    handleSaveAddressError(error) {
      this.$refs.spinner.hideSpinner();
    },
    /**
     * This function handles the response of saves new address
     */
    handleSaveAddressResponse(response) {
      this.$refs.spinner.hideSpinner();
      this.addressAvailable = true;
      this.deliveryId = response.data.id;
      this.useThisAddress();
    },
    /**
     * This function saves the shipping address selected and check for shipping restrictions happens
     */
    toggleViewMode(event) {
      this.splitEntries = [];
      this.shippingDetails = [];
      this.splitEntryDataArray = [];
      this.quantityError = false;
      this.addressEmptyError = false;
      this.splitToSameAddressError = false;
      for (let i = 0; i < this.$refs.splitQtyAddress.length; i += 1) {
        const splitEntryData = this.$refs.splitQtyAddress[
          i
        ].productSplitEntryData();

        this.splitEntryDataArray.push(splitEntryData);
      }
      if (this.splitEntryDataArray && this.splitEntryDataArray.length !== 0) {
        for (let j = 0; j < this.splitEntryDataArray.length; j += 1) {
          if (this.splitEntryDataArray[j]) {
            this.shippingDetails.push(this.splitEntryDataArray[j].addressData);
            this.splitEntries.push(this.splitEntryDataArray[j].productData);
            this.allSelectedAddresses.push(
              this.splitEntryDataArray[j].allAddresses,
            );
          }
        }
      }
      if (this.allSelectedAddresses && this.allSelectedAddresses.length !== 0) {
        this.splitShippingAddresses(this.allSelectedAddresses);
      }
      if (
        this.splitEntries.length !== 0 &&
        !this.quantityError &&
        !this.addressEmptyError &&
        !this.splitToSameAddressError
      ) {
        this.checkoutService.shippingRestriction(
          {},
          this.handleUseAddressResponse,
          this.handleUseAddressError,
          this.saveRequestData(),
        );
        if (event) {
          this.useAddressClicked = true;
        } else {
          this.useAddressClicked = false;
        }
        this.$refs.spinner.showSpinner();
      }
    },
    /**
     * This function finds restricted products
     * @param  {Number} productCode product Code
     */
    checkRestricted(productCode) {
      let isRestricted = false;
      for (let i = 0; i < this.restrictedItems.length; i += 1) {
        if (this.restrictedItems[i].productCode === productCode) {
          isRestricted = true;
          break;
        }
      }
      return isRestricted;
    },
    /**
     * This function is triggered when user successfully saves shipping address
     * @param  {Object} data address
     */
    switchToSaveMode(data) {
      if (data && data.length !== 0) {
        this.isSaved = true;
        this.isEditable = false;
        this.uniqueSavedAddresses = data;
        const savedDataFlags = {
          isSaved: this.isSaved,
          isEditable: this.isEditable,
        };
        this.$emit('addressSaved', savedDataFlags);
      }
    },
    /**
     * This function handles response of saving the shipping address and switches to read only mode
     */
    handleUseAddressResponse(response) {
      this.$refs.spinner.hideSpinner();
      this.restrictedItems = response.data.shippingDetails;
      if (this.restrictedItems.length === 0) {
        this.dismissFlyout();
        this.switchToSaveMode(this.uniqueSavedAddresses);
        if (response && this.useAddressClicked) {
          if (globals.isB2B()) {
            this.sendEventToDataLayer('checkout_option', 2, 'Use This Address');
          }
          checkoutEventBus.$emit('use-this-address-clicked');
        }
        checkoutEventBus.$emit('update-cart');
      } else {
        this.restrictionError = true;
        this.allSelectedAddresses = [];
        this.showFlyout(
          'error',
          `${this.i18n.shippingAddress.flyoutRestrictionErrorPart1} ${
            this.restrictedItems[0].region.isocode
          }${this.i18n.shippingAddress.flyoutRestrictionErrorPart2}`,
          false,
        );
      }
      checkoutEventBus.$emit('restriction-error', this.restrictedItems);
    },
    /**
     * This function handles error of saving shipping address and displays error
     */
    handleUseAddressError(error) {
      this.$refs.spinner.hideSpinner();
    },
    /**
     * This function deletes a product from cart
     * @param  {Number} itemNumber product entryNumber
     * @param  {Number} productCode product code
     */
    deleteCartItem(itemNumber, productCode, event) {
      this.deleteRestrictedProductCode = productCode;
      this.checkoutService.deleteCartItem(
        {},
        this.handleDeleteCartItemResponse,
        this.handleDeleteCartItemError,
        itemNumber,
      );
      this.$refs.spinner.showSpinner();
    },
    /**
     * This function handles the response of delete product call
     */
    handleDeleteCartItemResponse() {
      this.$refs.spinner.hideSpinner();
      checkoutEventBus.$emit('update-cart');
      this.restrictedItems.map((item, index) => {
        if (item.productCode === this.deleteRestrictedProductCode) {
          this.restrictedItems.splice(index, 1);
        }
      });
      if (this.restrictedItems.length === 0) {
        this.dismissFlyout();
      }
    },
    /**
     * This function handles the error of delete product call
     */
    handleDeleteCartItemError() {
      this.$refs.spinner.hideSpinner();
    },
    /**
     * This function splits the shipping address for a product
     */
    splitShippingAddresses(data) {
      this.allSelectedAddresses = _.flattenDeep(this.allSelectedAddresses);
      this.uniqueSavedAddresses = _.uniqBy(this.allSelectedAddresses, 'id');
    },
    showSplitError(data) {
      if (data && data.quantityError) {
        this.quantityError = true;
        this.showFlyout('error', this.i18n.shippingAddress.quantityError, true);
      } else if (data && data.addressEmptyError) {
        this.addressEmptyError = true;
      } else if (data && data.splitToSameAddressError) {
        this.splitToSameAddressError = true;
        this.showFlyout(
          'error',
          'Splitted quantity  cannot be shipped to same address',
          true,
        );
      }
    },
    /**
     * This function forms address object with label as address string and value as address object
     * @param  {Array} addressArray address Array
     */
    formAddressValues(addressArray) {
      let addressObject = {};
      this.currentAvailableAddresses = [];
      if (addressArray.length !== 0) {
        for (let i = 0; i < addressArray.length; i += 1) {
          addressObject = {
            label: this.formAddressString(addressArray[i]),
            value: addressArray[i],
          };
          this.currentAvailableAddresses.push(addressObject);
        }
      }
      this.currentAvailableAddresses.sort((a, b) => {
        const x = a.value.line1.toLowerCase();
        const y = b.value.line1.toLowerCase();
        if (x < y) {
          return -1;
        } else if (x > y) {
          return 1;
        }
        return 0;
      });
      for (let j = 0; j < this.currentAvailableAddresses.length; j += 1) {
        if (
          this.currentAvailableAddresses &&
          this.currentAvailableAddresses.length !== 0 &&
          this.currentAvailableAddresses[j].value &&
          this.currentAvailableAddresses[j].value.defaultAddress
        ) {
          this.defaultAddress = this.currentAvailableAddresses[j];
          this.currentAvailableAddresses.splice(
            this.currentAvailableAddresses.indexOf(this.defaultAddress),
            1,
          );
          this.currentAvailableAddresses.unshift(this.defaultAddress);
          break;
        }
      }
      return this.currentAvailableAddresses;
    },
    /**
     * This function creates address string formation to display in dropdown
     * @param  {Object} address address
     */
    formAddressString(address) {
      let userAddress = '';
      let companyName = '';
      const name = `${address.firstName} ${address.lastName}`;
      if (address && address.companyName) {
        companyName = address.companyName;
      }
      if (address) {
        userAddress = [
          name,
          companyName,
          address.line1,
          address.line2,
          address.town,
          address.region.isocodeShort,
          address.postalCode,
          address.country.isocode,
        ]
          .filter(Boolean)
          .join(', ');
      }
      return userAddress;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/checkout/vx-multi-shipping-address/vx-multi-shipping-address.js